"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADD_IMAGE_SIMPLE_RETURN = void 0;
var client_1 = require("@apollo/client");
exports.ADD_IMAGE_SIMPLE_RETURN = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation AddImageSimpleReturn($input: AddImageInput!) {\n    addImage(input: $input) {\n      image {\n        id\n        saved\n      }\n    }\n  }\n"], ["\n  mutation AddImageSimpleReturn($input: AddImageInput!) {\n    addImage(input: $input) {\n      image {\n        id\n        saved\n      }\n    }\n  }\n"])));
var templateObject_1;
